module.exports = __webpack_public_path__ + "img/stylish.b0eba397.png";